export enum ValueType {
  CurrencyValue,
  Number,
  Percentage,
  TickerSymbol,
}
